export default {
  setFormField (state, { field, value }) {
    state.form[field] = value
    if (field === 'opportunityId') {
      state.oppIdValidated = false
      if (state.formErrors && state.formErrors.opportunityId) {
        const updatedErrors = { ...state.formErrors }
        delete updatedErrors.opportunityId
        state.formErrors = updatedErrors
      }
    }
  },
  setFormErrors (state, errors) {
    state.formErrors = errors
  },
  setFormErrorField (state, { field, message }) {
    if (!message) {
      if (state.formErrors && Object.prototype.hasOwnProperty.call(state.formErrors, field)) {
        const updatedErrors = { ...state.formErrors }
        delete updatedErrors[field]
        state.formErrors = updatedErrors
      }
    } else {
      state.formErrors = {
        ...state.formErrors,
        [field]: message
      }
    }
  },
  clearFormErrors (state) {
    state.formErrors = {}
  },
  setIsSubmitting (state, value) {
    state.isSubmitting = value
  },
  setSubmitError (state, error) {
    state.submitError = error
  },
  setSubmitSuccess (state, value) {
    state.submitSuccess = value
  },
  resetForm (state) {
    state.form = {
      customerName: '',
      opportunityId: '',
      awsAccountIds: '',
      supportingPdl: '',
      contactEmail: '',
      contactName: '',
      requestManagedServices: false,
      wbsCode: '',
      targetDeploymentDate: '',
      customizationDescription: ''
    }
    state.isValidatingOppId = false
    state.oppIdValidated = false
    state.formErrors = {}
    state.submitError = null
    state.submitSuccess = false
  },
  setRequests (state, requests) {
    if (Array.isArray(state.requests) && state.requests.length > 0) {
      state.requests = [...state.requests, ...requests]
    } else {
      state.requests = requests
    }
  },
  clearRequests (state) {
    state.requests = []
  },
  setIsLoading (state, value) {
    state.isLoading = value
  },
  setSelectedRequest (state, request) {
    state.selectedRequest = request
  },
  setNextPageKey (state, nextPageKey) {
    state.nextPageKey = nextPageKey
  },
  setIsValidatingOppId (state, value) {
    state.isValidatingOppId = value
  },
  setOppIdValidated (state, value) {
    state.oppIdValidated = value
  },
  setOppIdData (state, data) {
    state.oppIdData = data
  },
  setCustomerName (state, customerName) {
    state.form.customerName = customerName
  }
}
